export const table = {
	defaultCategoryName: "Produtos",
	exportExcel: "Exportar Excel",
	productCount: {
		singular: "produto",
		plural: "produtos",
	},
	loading: {
		categories: "Carregando categorias",
		products: "Carregando Produtos",
	},
	dropdown: {
		editCategory: "Editar categoria",
		deleteCategory: "Excluir categoria",
		categoryButton: "Categoria",
	},
	columns: {
		bars: "Bares",
		barsTooltip: "Clique para visualizar os bares",
		barsLabel: "Bares",
		mountableTooltip: "Clique para ver o produto montável",
		productionRuleTooltip: "Clique para ver a regra de produção",
		active: "Situação",
		mountableDescription: "Montável",
		fiscalCode: "SKU",
		name: "Produto",
		category: "Categoria",
		hasProductionRule: "Ficha Técnica",
		fiscalData: "Dados Fiscais",
		value: "Preço",
		actions: "Ações",
	},
	fiscalStatus: {
		testedTooltip: "Dados fiscais cadastrados e validados",
		errorTooltip: "Encontramos erros nos dados fiscais apresentados",
		notTestedTooltip: "Dados fiscais cadastrados. Aguardando teste.",
	},
	variablePrice: "Variável",
	validation: {
		pricePositive: "O preço deve ser um valor positivo",
		maxValue: "O preço não deve exceder o valor máximo permitido (21.474.836,47)",
	},
	priceUpdateSuccess: "O preço de {{productName}} foi atualizado com sucesso.",
	priceChangeModal: {
		title: "Alterar preço do produto",
		description:
			"Você está alterando o preço do produto <strong>{{productName}}</strong> para <strong>{{price}}</strong>.",
		secondParagraph:
			"Antes de sair da edição do preço, confirme se deseja continuar com a alteração ou cancelar.",
		cancelButton: "Cancelar",
		confirmButton: "Alterar preço",
	},
	priceChangeInvalidModal: {
		title: "Valor inválido",
		description:
			"O valor inserido não é válido. O preço anterior do produto será mantido.",
		cancelButton: "Cancelar",
	},
	priceUpdateCancelledNotification: {
		title: "Não foi possível atualizar o preço",
		description: "Mantemos o último preço no produto",
	},
	priceUpdateSuccessNotification: {
		title: "Preço atualizado com sucesso!",
		description: "{{productName}} foi atualizado para {{price}}",
	},
	notifications: {
		copyImageSuccess: {
			title: "Sucesso!",
			description: "Hash da imagem copiado para a área de transferência",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Categoria sem produtos",
		noProductsFound: "Nenhum produto encontrado",
		noProductsCreated: "Nenhum produto criado",
		noProductsCreatedMessage:
			"Crie seu primeiro produto e vincule a uma categoria para aparecer aqui",
		addProducts: "Adicione produtos e vincula a está categoria.",
		addProductButton: "Adicionar produto",
		noSearchResults: "Não encontramos produtos que correspondam à sua busca por",
		clearSearchButton: "Limpar busca",
		clearFiltersButton: "Limpar filtros",
		andToAppliedFilters: "e aos filtros aplicados",
		noProductsMatchingFilters:
			"Não encontramos produtos que correspondam aos filtros aplicados",
	},
};
